(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    class ProductMediaHover extends HTMLElement {
      connectedCallback() {
        this.images = Array.from(this.querySelectorAll('img'));
        this.activeIndex = 0;
        this.zoomTimer = null;
        this.cycleTimer = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // The card's full-card link overlay sits above this element in paint
        // order, so it (not this element) receives real pointer hover.
        // Listen on the shared card-wrapper ancestor instead.
        this.hoverRoot = this.closest('.card-wrapper') || this;
        this.hoverRoot.addEventListener('mouseenter', this.onEnter.bind(this));
        this.hoverRoot.addEventListener('mouseleave', this.onLeave.bind(this));
        this.hoverRoot.addEventListener('focusin', this.onEnter.bind(this));
        this.hoverRoot.addEventListener('focusout', this.onLeave.bind(this));
      }

      onEnter() {
        if (this.reducedMotion || this.images.length === 0) return;
        this.classList.add('is-zooming');
        if (this.images.length > 1) {
          this.zoomTimer = setTimeout(() => this.startCycle(), 0);
        }
      }

      startCycle() {
        this.cycleTimer = setInterval(() => {
          this.activeIndex = (this.activeIndex + 1) % this.images.length;
          this.images.forEach((img, i) => {
            img.classList.toggle('is-active', i === this.activeIndex);
          });
        }, 1000);
      }

      onLeave() {
        clearTimeout(this.zoomTimer);
        clearInterval(this.cycleTimer);
        this.classList.remove('is-zooming');
        this.activeIndex = 0;
        this.images.forEach((img, i) => {
          img.classList.toggle('is-active', i === 0);
        });
      }
    }

    if (!customElements.get('product-media-hover')) {
      customElements.define('product-media-hover', ProductMediaHover);
    }
  } catch(e) { console.error(e); }
})();

})();
